<template>
  <title-navigation-link-panel :title="title"
                               @next="$refs.carousel.swiper.slideNext()"
                               @previous="$refs.carousel.swiper.slidePrev()">
    <template #link>
      <slot name="link"></slot>
    </template>

    <template #carousel>
      <swiper-container  :slides-per-view="numberOfSlides"
                         :slides-per-group="numberOfSlides"
                         ref="carousel"
                         :space-between="30"
                         :enabled="true"
                         loading="lazy">
        <slot name="slide"></slot>
      </swiper-container>
    </template>
  </title-navigation-link-panel>
</template>

<script>
import TitleNavigationLinkPanel from "./Panels/TitleNavigationLinkPanel.vue";
import { register } from 'swiper/element/bundle';
import 'swiper/swiper-bundle.css';

export default {
  name: "GroupSwiperCarousel",
  components: {TitleNavigationLinkPanel},

  props: {
    mobileItems: { required: true },
    tabletItems: { required: true },
    desktopItems: { required: true },
    title: { required: false }
  },

  created() {
    register();
  },

  computed: {
    numberOfSlides () {
      if (this.$mq.lg) { return this.desktopItems }

      if (this.$mq.md) { return this.tabletItems }

      return this.mobileItems
    }
  }
}
</script>
